<template>
    <div class="living-options-property-models">
      <div class="row">
        <div class="col-12">
          <div class="property-models">
            <h5>Property Models</h5>
            <button class="btn btn-primary mb-4" @click="addPropertyModel()" :disabled="isAddingNewObject('propertyModels')">Add Property Model</button>
            <div>
              Filter Property Models
              <input class="mb-4" type="text" v-model="propertyModelFilterText" placeholder="Salt 101">
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>Label</th>
                  <th>Type</th>
                  <th>Beds</th>
                  <th>Baths</th>
                  <th>Cars</th>
                  <th>Price</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="propertyModel in filteredPropertyModels"
                  :key="propertyModel._id"
                >
                  <td><span v-if="propertyModel.isFromCRM" class="tag-crm">CRM</span> {{ propertyModel.label }}</td>
                  <td>{{ propertyModel.type }}</td>
                  <td>{{ propertyModel.beds }}</td>
                  <td>{{ propertyModel.baths }}</td>
                  <td>{{ propertyModel.cars }}</td>
                  <td>{{ propertyModel.price }}</td>
                  <td class="text-right table__button-cell">
                    <button class="btn btn-sm btn-outline-danger ml-1" @click="deletePropertyModel(propertyModel._id)">Delete</button>
                    <button class="btn btn-sm btn-outline-secondary ml-1" @click="clonePropertyModel(propertyModel._id)">Clone</button>
                    <button class="btn btn-sm btn-primary ml-1" @click="activePropertyModelId = propertyModel._id">Edit</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <modal-popup :isVisible="!!activePropertyModel">
              <div v-if="activePropertyModel" class="modal-row-padding" v-click-outside="closeModal">
                <div v-if="activePropertyModel.isFromCRM">
                  <span class="tag-crm ml-0 mb-3">CRM</span>
                </div>

                <div class="row">
                  <div v-if="userAccess.indexOf('propertyModelLabel') !== -1" class="col-6">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Label</label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.label }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.label"
                        placeholder="i.e. apartment"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelType') !== -1" class="col-6">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Type</label>
                      <select class="form-control form-control-lg" v-model="activePropertyModel.type">
                        <option value="">Select Model Type</option>
                        <option value="Apartment">Apartment</option>
                        <option value="House">House</option>
                        <option value="Terrace">Terrace</option>
                      </select>
                    </fieldset>
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelBeds') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Bedrooms</label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.beds }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.beds"
                        placeholder="i.e. 2"
                      />
                    </fieldset>
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelBaths') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Bathrooms</label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.baths }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.baths"
                        placeholder="i.e. 1"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelCars') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Car Spaces</label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.cars }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.cars"
                        placeholder="i.e. 1"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelAspect') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Aspect</label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.aspect }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.aspect"
                        placeholder="i.e. West"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelFloorPlan') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Floor Plan</label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.floor_plan }}</div>
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.floor_plan"
                        placeholder="i.e. Ivy A"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelLivingMsq') !== -1 && activePropertyModel.type == 'House'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Living m<sup>2</sup></label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.living_msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.living_msq"
                        placeholder="i.e. 55"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelOutdoorMsq') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Outdoor m<sup>2</sup></label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.outdoor_msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.outdoor_msq"
                        placeholder="i.e. 55"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelMsq') !== -1" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Total m<sup>2</sup></label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.msq }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.msq"
                        placeholder="i.e. 85"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelPrice') !== -1 && activePropertyModel.type == 'House'" class="col-3">
                    <fieldset class="form-group">
                      <label><span class="dot" :class="{ 'dot--crm' :activePropertyModel.isFromCRM }"></span>Price</label>
                      <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.price }}</div>
                      <input
                        v-else
                        type="number"
                        class="form-control form-control-lg"
                        v-model="activePropertyModel.price"
                        placeholder="i.e. 400000"
                        :disabled="activePropertyModelId !== activePropertyModel._id"
                      />
                    </fieldset>                                                    
                  </div>
                </div>

                <div class="row">
                  <div v-if="userAccess.indexOf('propertyModelFeatures') !== -1" class="col-12">
                    <fieldset class="form-group">
                      <label><span class="dot"></span>Features</label>
                      <ck-editor v-model="activePropertyModel.features"></ck-editor>
                    </fieldset>                                                    
                  </div>
                  <div v-if="userAccess.indexOf('propertyModelImages') !== -1" class="col-12">
                    <fieldset class="form-group">
                      <label><span class="dot"></span>Images</label>
                      <input-asset v-model="activePropertyModel.images" :multiple="true" defaultCategory="pageBackground" requirements="Required dimensions: 3040x1960px<br>Supported formats: jpg, png"></input-asset>
                    </fieldset>
                  </div>
                  <div class="col-12">
                    <button v-if="activePropertyModelId !== activePropertyModel._id" class="" @click="activePropertyModelId = activePropertyModel._id">Edit</button>
                    <button v-if="activePropertyModelId === activePropertyModel._id" class="btn btn-sm btn-outline-danger" @click="activePropertyModelId = null">Cancel</button>
                    <button v-if="activePropertyModelId === activePropertyModel._id" class="btn btn-sm btn-primary ml-1" @click="saveActivePropertyModel()">Save</button>
                  </div>
                </div>
              </div>             
            </modal-popup>
          </div>
        </div>
      </div>
    </div>     
</template>
<script>
import _ from 'lodash'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import ModalPopup from '@/components/ModalPopup'
import CkEditor from '@/components/CKEditor'

export default {
  components: { InputAsset, InputMultiSelect, ModalPopup, CkEditor },
  data () {
    return {
      activePropertyModelId: null,
      propertyModelFilterText: '',
    }
  },

  computed: {
    activePropertyModel () {
      return _.find(this.propertyModels, propertyModel => {
        return propertyModel._id === this.activePropertyModelId
      })
    },

    filteredPropertyModels () {
      return _.filter(this.propertyModels, propertyModel => {
        return propertyModel.label.toLowerCase().includes(this.propertyModelFilterText.toLowerCase())
      })
    },

    propertyModels: {
      get () {
        return this.$store.getters.propertyModels
      },
      set (properties) {
        this.$store.commit('SET_PROPERTY_MODELS', propertyModels)
      }
    },

    userAccess () {
      return this.$store.getters.user.access ? this.$store.getters.user.access : []
    }
  },

  methods: {
    addPropertyModel () {
      const propertyModel = {
        _id: 'temp',
        label: '',
        displayName: '',
        type: '',
        beds: '',
        baths: '',
        images: []
      }
      this.$store.commit('ADD_PROPERTY_MODEL', propertyModel)
      this.activePropertyModelId = propertyModel._id
    },

    clonePropertyModel (id) {
      const propertyModel = _.find(this.propertyModels, propertyModel => {
        return propertyModel._id === id
      })

      let clonedPropertyModel = _.clone(propertyModel)

      clonedPropertyModel._id = 'temp'
      clonedPropertyModel.label += '-COPY'
      clonedPropertyModel.isFromCRM = false

      this.$store.commit('ADD_PROPERTY_MODEL', clonedPropertyModel)
      this.activePropertyModelId = clonedPropertyModel._id
    },

    closeModal () {
      this.$store.dispatch('FETCH_PROPERTY_MODELS')
      this.activePropertyModelId = null
    },

    deletePropertyModel (id) {
      this.$store.dispatch('DELETE_PROPERTY_MODEL', id)
    },

    isAddingNewObject () {
      return Boolean(_.map(this.propertyModels, propertyModel => { return propertyModel._id }).includes('temp'))
    },

    saveActivePropertyModel () {
      this.$store.dispatch('SAVE_PROPERTY_MODEL', this.activePropertyModel)
      this.activePropertyModelId = null
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PROPERTY_MODELS')
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";

  select {
    width: 100%;
  }

  .card {
    z-index: unset !important;
  }

  .living-option, .subsection, .property, .property-model {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;
    margin: 1em 0;
  }

  .selection-list {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;   
    max-height: 200px;
    // overflow: scroll; 
  }

  .list-wrapper {
    max-height: 600px;
    // overflow: scroll;
  }

  .living-options-property-models {
    table {
      border-collapse: separate;
      border-spacing: 0;
      border: 1px solid #d4d4d4;
      border-radius: 6px;
      // overflow: hidden;
      width: 100%;
    }

    .table__button-cell button {
      opacity: 0;
    }

    tbody {
      display: block;
      max-height: none;
      overflow: auto;

      @include v-breakpoint(800px) {
        max-height: calc(100vh - 500px);
      }

      tr:hover {
        background-color: #f5f5f5;
        .table__button-cell button {
          opacity: 1;
        }
      }
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
      background-color: #f0f0f0;
      border-bottom: 1px solid #d4d4d4;
      font-size: 12px;
      position: sticky;
      text-transform: uppercase;
      top: 0;
      z-index: 10;
    }

    th, td {
      font-weight: 400;
      padding: 10px 15px;
    }

    tr {
      &:nth-child(2n) {
        background-color: #fafafa;
      }
    }
  }

  .modal-row-padding {
    padding: 30px 0;
  }
</style>